/** Static portraits for the sample family, keyed by the person ids in `sampleBackup()` (`daniel` → daniel.jpg). */
export const samplePortraitUrl = (key: string) => `/sample/portraits/${key}.jpg`;
